var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryTrackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.71,
    height: 39.407,
    viewBox: "0 0 37.71 39.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history_1_",
    "data-name": "history (1)",
    transform: "translate(-5.205 -3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M6.676,44.031H33.8a1.469,1.469,0,0,0,1.464-1.471V36.014h-.025c-.305.028-.614.043-.931.043a10.01,10.01,0,1,1,0-20.02c.317,0,.626.015.931.044h.025V7.574A1.466,1.466,0,0,0,33.8,6.11H26.6V7.728a2.147,2.147,0,0,1-2.137,2.147H16.019a2.147,2.147,0,0,1-2.144-2.146V6.111h-7.2A1.469,1.469,0,0,0,5.205,7.574V42.561a1.473,1.473,0,0,0,1.471,1.471Zm9.066-30.538H30.485a.7.7,0,0,1,0,1.407H15.741a.7.7,0,0,1,0-1.407Zm0,4.852H24.23a.7.7,0,0,1,0,1.407H15.741a.7.7,0,0,1,0-1.407Zm0,4.852h6.765a.7.7,0,0,1,0,1.407H15.741a.7.7,0,0,1,0-1.407Zm0,4.852h6.765a.7.7,0,0,1,0,1.407H15.741a.7.7,0,1,1,0-1.407Zm0,4.852H24.23a.7.7,0,1,1,0,1.407H15.741a.7.7,0,1,1,0-1.407Zm0,4.852H30.485a.7.7,0,0,1,0,1.407H15.741a.7.7,0,1,1,0-1.407ZM9.987,13.493h1.907a.7.7,0,0,1,0,1.407H9.987a.7.7,0,0,1,0-1.407Zm0,4.852h1.907a.7.7,0,0,1,0,1.407H9.987a.7.7,0,0,1,0-1.407Zm0,4.852h1.907a.7.7,0,0,1,0,1.407H9.987a.7.7,0,0,1,0-1.407Zm0,4.852h1.907a.7.7,0,1,1,0,1.407H9.987a.7.7,0,1,1,0-1.407Zm0,4.852h1.907a.7.7,0,1,1,0,1.407H9.987a.7.7,0,1,1,0-1.407Zm0,4.852h1.907a.7.7,0,0,1,0,1.407H9.987a.7.7,0,0,1,0-1.407Z",
    transform: "translate(0 -0.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M44.477,22.357a8.491,8.491,0,0,0-1.536-.137,8.6,8.6,0,1,0,0,17.205,8.441,8.441,0,0,0,1.535-.137,8.6,8.6,0,0,0,0-16.931Zm1.76,11.76a.7.7,0,0,1-1,0l-2.8-2.8a.7.7,0,0,1-.206-.5V25.14a.7.7,0,1,1,1.407,0v5.39l2.592,2.592A.7.7,0,0,1,46.237,34.117Z",
    transform: "translate(-8.632 -5.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M20.262,4a.737.737,0,0,0-.736.736V7.106a.718.718,0,0,0,.015.077.689.689,0,0,0,.722.657H28.7a.734.734,0,0,0,.73-.735V4.735A.733.733,0,0,0,28.7,4H20.261Z",
    transform: "translate(-4.244)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryTrackIcon);
export default __webpack_public_path__ + "static/media/HistoryTrack_icon.b4a977bba1e10a941f45b31762110bf9.svg";
export { ForwardRef as ReactComponent };